(() => {
    window.Dashboard = window.Dashboard || {};

    window.Dashboard.Models = window.Dashboard.Models || {};

    /**
     * The Campaign voucher model for Yumbi Campaigns
     * @constructor
     */
    class CampaignVoucherTemplate {
        /**
         * The Id of the campaign voucher template
         * @type {number}
         */
        Id = 0;

        /**
         * The campaign voucher guid
         * @type {string}
         */
        CampaignVoucherGuid = undefined;

        /**
         * The campaign template id
         * @type {number}
         */
        CampaignTemplateId = undefined;

        /**
         * The name of the campaign voucher template
         * @type {string}
         */
        Name = undefined;

        /**
         * The description of the campaign voucher template
         * @type {string}
         */
        Description = undefined;

        /**
         * The voucher code
         * @type {string}
         */
        VoucherCode = undefined;

        /**
         * The estimated order discount
         * @type {number}
         */
        EstimatedOrderDiscount = 0;

        /**
         * The amount of days after enrollment the voucher will expire
         * @type {?number}
         */
        ExpiryDaysOverride = undefined;

        /**
         * The created date
         * @type {Date}
         */
        Created = undefined;

        /**
         * The new instance script
         * @type {string}
         */
        NewInstanceScript = '';

        /**
         * Is the voucher discount a percentage discount
         * @type {boolean}
         */
        IsPercentageDiscount = false;

        /**
         * Initialises the campaign with the campaign returned from the API
         */
        initialiseCampaignVoucherTemplate(campaignVoucherTemplate) {
            return _.extend(this, campaignVoucherTemplate);
        }

        /**
         * Validates the campaign template voucher
         * @param { ErrorService } errorService
         * {boolean}
         */
        Validate(errorService) {
            let validationPassed = true;

            if (_.isEmpty(this.Name)) {
                errorService.showError('Name Required', null);
                validationPassed = false;
            }

            if (_.isEmpty(this.Description)) {
                errorService.showError('Description Required', null);
                validationPassed = false;
            }

            if (_.isEmpty(this.VoucherCode)) {
                errorService.showError('Voucher code Required', null);
                validationPassed = false;
            }

            if (this.EstimatedOrderDiscount <= 0) {
                errorService.showError('Estimated order discount must be greater than zero', null);
                validationPassed = false;
            }

            if (this.ExpiryDaysOverride < 1 || _.isNaN(this.ExpiryDaysOverride)) {
                this.ExpiryDaysOverride = null;
            }

            return validationPassed;
        }
    }

    window.Dashboard.Models.CampaignVoucherTemplate = CampaignVoucherTemplate;
})();
